/* ==========================================================================
   Pussy Liquor popups
   1. Age gate  - once per VISIT. "Yes" marks this browser tab's session (via
                  sessionStorage, not localStorage) so moving between pages
                  does not ask again — but sessionStorage clears itself when
                  the tab/browser is closed, so a later visit always asks
                  again, new or returning user alike. Opens the coming soon
                  popup straight after. "No" redirects or shows a message.
   2. Coming soon - email capture (Shopify customer form, submitted with fetch), remembered
                  for N days after it is closed.
   Both are native <dialog> elements (focus trap, Esc, inert page behind).
   ========================================================================== */
(function () {
  'use strict';

  var AGE_SESSION_KEY = 'pl_age_ok_session';
  var SOON_KEY = 'pl_soon_seen';
  var SUB_KEY = 'pl_soon_sub';
  var root = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function read(key) {
    try { return parseInt(localStorage.getItem(key), 10) || 0; } catch (e) { return 0; }
  }
  function write(key) {
    try { localStorage.setItem(key, String(Date.now())); } catch (e) { /* private mode: asks again next visit */ }
  }
  function fresh(key, days) {
    var t = read(key);
    return !!t && Date.now() - t < days * 864e5;
  }
  function ageConfirmedThisVisit() {
    /* sessionStorage, deliberately: it survives page-to-page navigation in
       this tab but is gone the moment the tab/browser closes, so "once per
       visit, asks again next time" falls out of the browser's own behaviour
       rather than any date math here. */
    try { return sessionStorage.getItem(AGE_SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function markAgeConfirmed() {
    try { sessionStorage.setItem(AGE_SESSION_KEY, '1'); } catch (e) { /* private mode: asks again on the next page, which is an acceptable fallback */ }
  }
  function lock(on) {
    root.classList.toggle('pl-pop-lock', on);
  }
  function show(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    lock(true);
  }
  function hide(dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function setup(host) {
    if (host.dataset.plReady) return;
    host.dataset.plReady = '1';

    var age = host.querySelector('[data-pl-age]');
    var soon = host.querySelector('[data-pl-soon]');
    var soonDays = parseInt(host.dataset.soonDays, 10);
    if (isNaN(soonDays)) soonDays = 1;

    function anyOpen() {
      return (age && age.open) || (soon && soon.open);
    }
    [age, soon].forEach(function (d) {
      if (!d) return;
      d.addEventListener('close', function () { lock(anyOpen()); });
    });

    /* ---------- Coming soon ---------- */
    function soonDue() {
      if (!soon || host.dataset.soon !== 'true') return false;
      if (designMode) return true;
      if (fresh(SUB_KEY, 365)) return false; /* already signed up */
      /* 0 days = every new visit, so remember per browser session instead */
      if (soonDays === 0) {
        try { return sessionStorage.getItem(SOON_KEY) !== '1'; } catch (e) { return true; }
      }
      return !fresh(SOON_KEY, soonDays);
    }
    function markSoonSeen() {
      if (designMode) return;
      if (soonDays === 0) {
        try { sessionStorage.setItem(SOON_KEY, '1'); } catch (e) { /* ignore */ }
      } else {
        write(SOON_KEY);
      }
    }
    function openSoon() {
      if (!soonDue()) return;
      setTimeout(function () { show(soon); }, 250);
    }

    if (soon) {
      soon.addEventListener('close', function () { markSoonSeen(); });
      soon.addEventListener('click', function (e) {
        if (e.target === soon) hide(soon); /* backdrop */
      });
      var closeBtn = soon.querySelector('[data-pl-soon-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { hide(soon); });

      var form = soon.querySelector('.pl-pop__form');
      if (form) {
        form.noValidate = true;
        var input = form.querySelector('input[type="email"]');
        var fields = form.querySelector('.pl-pop__fields');
        var err = form.querySelector('[data-pl-soon-error]');
        var ok = form.querySelector('[data-pl-soon-ok]');
        var busy = false;

        function showError(msg) {
          input.setAttribute('aria-invalid', 'true');
          err.textContent = msg;
          err.hidden = false;
        }
        function showSuccess() {
          fields.hidden = true;
          err.hidden = true;
          ok.hidden = false;
          if (!designMode) write(SUB_KEY); /* they signed up: don't ask again for a year */
        }

        input.addEventListener('input', function () {
          input.removeAttribute('aria-invalid');
          err.hidden = true;
        });

        form.addEventListener('submit', function (e) {
          var value = input.value.trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            e.preventDefault();
            showError('Please enter a valid email address.');
            input.focus();
            return;
          }
          if (!window.fetch || !window.FormData) return; /* normal post as a fallback */
          e.preventDefault();
          if (busy) return;
          busy = true;
          fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
            .then(function (res) {
              if (/\/challenge/.test(res.url)) { form.submit(); return; } /* Shopify wants a captcha */
              if (/customer_posted=true/.test(res.url)) showSuccess();
              else showError('Something went wrong. Please try again.');
            })
            .catch(function () { form.submit(); })
            .then(function () { busy = false; });
        });

        /* page came back from a normal (non-JS) post */
        if (form.querySelector('[data-pl-posted]')) {
          setTimeout(function () { show(soon); }, 150);
        }
      }
    }

    /* ---------- Age gate ---------- */
    if (age && host.dataset.age === 'true') {
      var ask = age.querySelector('[data-pl-age-ask]');
      var denied = age.querySelector('[data-pl-age-denied]');
      var redirect = host.dataset.ageRedirect;

      /* it is a gate: Esc must not dismiss it */
      age.addEventListener('cancel', function (e) { e.preventDefault(); });

      age.querySelector('[data-pl-age-yes]').addEventListener('click', function () {
        markAgeConfirmed();
        hide(age);
        openSoon();
      });
      age.querySelector('[data-pl-age-no]').addEventListener('click', function () {
        if (redirect) {
          window.location.href = redirect;
          return;
        }
        ask.hidden = true;
        denied.hidden = false;
        var h = denied.querySelector('h2');
        if (h) h.focus();
      });
      age.querySelector('[data-pl-age-back]').addEventListener('click', function () {
        denied.hidden = true;
        ask.hidden = false;
        var yes = age.querySelector('[data-pl-age-yes]');
        if (yes) yes.focus();
      });

      if (!designMode) {
        root.classList.remove('pl-age-pending');
        if (ageConfirmedThisVisit()) {
          openSoon(); /* already said yes earlier this visit: skip straight past the gate */
        } else {
          show(age);
        }
      } else {
        root.classList.remove('pl-age-pending');
      }
    } else {
      root.classList.remove('pl-age-pending');
      if (!designMode) openSoon();
    }

    /* Theme editor: clicking the section previews the age gate, leaving it closes everything */
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (!host.contains(e.target) && !e.target.contains(host)) return;
        if (ask && denied) { denied.hidden = true; ask.hidden = false; }
        show(age || soon);
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (!host.contains(e.target) && !e.target.contains(host)) return;
        hide(age);
        hide(soon);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-pl-pop]').forEach(setup);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
